module.exports = __webpack_public_path__ + "static/img/logo1.266718f.png";


//////////////////
// WEBPACK FOOTER
// ./static/h5/logo1.png
// module id = kUea
// module chunks = 0